import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  imageSeq: string;
  count: number;
}

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

const imageMap: Record<string, string> = {
  'category-pingxuan': 'https://readdy.ai/api/search-image?query=Elegant%20young%20university%20women%20on%20stage%20receiving%20awards%2C%20formal%20ceremony%20atmosphere%2C%20spotlight%20illumination%2C%20prestigious%20event%2C%20beautiful%20dresses%2C%20celebration%20moment&width=600&height=400&seq=category-pingxuan&orientation=landscape',
  'category-gushi': 'https://readdy.ai/api/search-image?query=Young%20female%20college%20student%20reading%20book%20under%20tree%20on%20campus%2C%20warm%20sunlight%2C%20peaceful%20atmosphere%2C%20inspirational%20portrait%2C%20natural%20beauty%2C%20soft%20photography&width=600&height=400&seq=category-gushi&orientation=landscape',
  'category-xiaoyuan': 'https://readdy.ai/api/search-image?query=Beautiful%20traditional%20Chinese%20university%20campus%20architecture%20with%20gardens%20and%20ponds%2C%20serene%20landscape%2C%20historic%20buildings%2C%20lush%20greenery%2C%20picturesque%20scenery&width=600&height=400&seq=category-xiaoyuan&orientation=landscape',
  'category-qingchun': 'https://readdy.ai/api/search-image?query=Happy%20group%20of%20university%20students%20laughing%20together%20on%20campus%20lawn%2C%20golden%20hour%20sunlight%2C%20youthful%20energy%2C%20friendship%20and%20joy%2C%20carefree%20college%20life%2C%20warm%20photography&width=600&height=400&seq=category-qingchun&orientation=landscape',
};

export default function CategoryCard({ slug, name, description, icon, color, imageSeq, count }: CategoryCardProps) {
  const imageUrl = imageMap[imageSeq] || imageMap['category-pingxuan'];

  return (
    <Link to={`/category/${slug}`} className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-background-300/60 transition-all duration-300">
      <div className="relative h-40 overflow-hidden">
        <img
          src={imageUrl}
          alt={name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${colorMap[color] || colorMap.primary}`}>
            <i className={`${icon} text-lg`}></i>
          </div>
          <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
            {name}
          </h3>
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3">
          {description}
        </p>
        <span className="text-xs text-foreground-500">{count} 篇文章</span>
      </div>
    </Link>
  );
}